import React, { useState } from "react";
import Modal from "../Common/Modal/Modal";
import Title from "../Global/Title/Title";
import { HEADING_LEVELS } from "../Global/GlobalConstants";

/**
 * Modal component for sharing saved products via email
 */
const ShareProductsModal = ({ 
  show, 
  onClose, 
  products, 
  shareThisUrl 
}) => {
  const [formData, setFormData] = useState({
    recipientEmail: "",
    emailSubject: "",
  });
  const [processing, setProcessing] = useState(false);
  const [validationError, setValidationError] = useState("");
  const [sent, setSent] = useState(false);

  const handleChange = (event) => {
    setFormData(values =>
      ({...values, [event.target.name]: event.target.value}));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const productCodes = products
      .reduce((accumulator, val) => accumulator + val.productCode + ",", "")
      .slice(0, -1); // Remove trailing comma

    const submitData = {
      ...formData,
      productCodes
    };

    let shareThisRequest = shareThisUrl + "?";
    for (const attr in submitData) {
      if (attr && attr !== "") {
        shareThisRequest += attr + "=" + submitData[attr] + "&";
      }
    }
    shareThisRequest = shareThisRequest.slice(0, -1); // Remove trailing &

    setProcessing(true);

    fetch(shareThisRequest, { method: "post" })
      .then((response) => {
        setProcessing(false);
        if (response.ok) {
          setFormData({ recipientEmail: "", emailSubject: "" });
          setValidationError("");
          setSent(true);
          return;
        }
        throw response.text();
      })
      .catch((error) => {
        if (error.then) {
          error.then((data) => {
            console.error(data);
            setValidationError(data);
          });
        } else {
          setValidationError("Unknown Error");
        }
      });
  };

  const handleClose = () => {
    if (sent) {
      setSent(false);
    }
    onClose();
  };

  const globalProps = window.globalProperties || {};

  return (
    <Modal 
      className="saved-products-controller__share-this-modal" 
      show={show} 
      handleClose={handleClose} 
      lastElementSelector=".saved-products-controller__share-this-submit"
    >
      <Title
        defaultLevel={HEADING_LEVELS.THREE}
        className="saved-products-controller__share-this-title"
      >
        {globalProps["shareThisTitle"] || "Share My List"}
      </Title>
      <form className="saved-products-controller__share-this-form" onSubmit={handleSubmit}>
        <label htmlFor="recipientEmail">
          {globalProps["recipientEmailLabel"] || "Recipient Email"}
        </label>
        <span className='saved-products-controller__share-this-notice'>
          {globalProps["shareThisInstructions"] || "Note: Does not support multiple recipient emails"}
        </span>
        <input
          className={`saved-products-controller__share-this-input ${validationError ? "error" : ""}`}
          name="recipientEmail"
          id="recipientEmail"
          type="email"
          value={formData.recipientEmail}
          onChange={handleChange}
          {...(processing && {disabled: "disabled"})}
          {...(validationError && {"aria-describedby": "share-this-validation"})}
        />
        <label htmlFor="emailSubject">
          {globalProps["subjectFieldLabel"] || "Subject"}
        </label>
        <input
          className={`saved-products-controller__share-this-input ${validationError ? "error" : ""}`}
          name="emailSubject"
          id="emailSubject"
          type="text"
          value={formData.emailSubject}
          maxLength="60"
          onChange={handleChange}
        />
        <p className='saved-products-controller__share-this-notice'>
          {globalProps["shareThisDisclaimer"] || "The entered emails will not be used for any advertising or marketing purposes."}
        </p>
        {validationError && (
          <div
            className="saved-products-controller__share-this-validation"
            id="share-this-validation"
            role="alert"
          >
            {validationError}
          </div>
        )}
        {processing ? (
          <button className="btn saved-products-controller__share-this-submit" type="submit" disabled="disabled">
            processing...
          </button>
        ) : (
          <button className="btn saved-products-controller__share-this-submit" type="submit">
            Send
          </button>
        )}
        {sent && (
          <div className="saved-products-controller__share-this-sent" role="alert">
            {globalProps["emailSentMessage"] || "Sent"}
          </div>
        )}
      </form>
    </Modal>
  );
};

export default ShareProductsModal;
